import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx } from "vue"

import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import {IconStyle} from "~/chat/ts/data/ISiteParams";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "CoreUiChatHistoryMessageButton"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    icon: {},
    isClient: { type: Boolean },
    type: {},
    opacity: { type: Boolean, default: true },
    circle: { type: Boolean },
    disabled: { type: Boolean },
    iconStyle: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {



let emits = __emit;

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_component_el_button, {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('click'))),
    disabled: __props.disabled,
    class: _normalizeClass({
            'text-truncate mw-100 button': true,
            'el-button--opacity': !__props.isClient && __props.opacity,
            'circle': __props.circle
        }),
    circle: __props.circle,
    type: __props.type
  }, {
    default: _withCtx(() => [
      (__props.icon)
        ? (_openBlock(), _createBlock(FontAwesomeIcon, {
            key: 0,
            icon: __props.icon,
            "icon-style": __props.iconStyle,
            class: _normalizeClass({'mr-2': !!_ctx.$slots.default && !__props.circle})
          }, null, 8, ["icon", "icon-style", "class"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["disabled", "class", "circle", "type"]))
}
}

})